module.exports = __webpack_public_path__ + "img/lpbody.f413f06e.jpg";